import React from 'react';
import { TLanguageIDs, IGroupsOfMediaSettings } from 'types';
import GroupImage from './GroupImage';
import Text from 'components/Text/Text';
import { FileSectionForStyleSettings } from 'components/UploaderAndDownloader/FileSectionForStyleSettings';
import style from './NormalDisplay.module.scss';

interface INormalDisplay {
	group: IGroupsOfMediaSettings;
	languageId: TLanguageIDs;
}

const NormalDisplay: React.FC<INormalDisplay> = ({ group, languageId }) => {
	const isMultipleImagesInBlock = group.key === 'cards' || group.key === 'split_payment_images';
	const listOfTypesOfMediaContent = [1, 2];

	const PDFFilesOfBlockWithMultipleImages = isMultipleImagesInBlock
		? group.items.filter((item) => item.mediaFileType === 3)
		: [];

	return (
		<div className={style.container}>
			<div className={style.images}>
				{group.items.map(
					(el) =>
						listOfTypesOfMediaContent.includes(el.mediaFileType) && (
							<GroupImage
								filePath={el.filePath}
								translationId={el.translationId}
								isNeedImgHeading={!group.isMultipleItems && isMultipleImagesInBlock}
								itemKey={el.key}
								languageId={languageId}
								key={el.translationId}
							/>
						),
				)}
			</div>

			<div className={style.additionalFiles}>
				{!!PDFFilesOfBlockWithMultipleImages.length &&
					PDFFilesOfBlockWithMultipleImages.map((item) => (
						<div key={item.translationId} className={style.additionalFile}>
							<Text
								translationNameSpace="mediaSettings"
								translationKey={item.key}
								theme="secondary"
								size="l"
								weight="bold"
								display="inline"
							/>
							<FileSectionForStyleSettings item={item} />
						</div>
					))}
			</div>
		</div>
	);
};

export default NormalDisplay;
